import React, { useEffect, useState } from 'react'

const Counter = ({ target, speed = 2000 }) => {
  const [count, setCount] = useState(0);

  useEffect(() => {
    let start = 0;
    const increment = target / (speed / 16); // approx 60fps

    const interval = setInterval(() => {
      start += increment;
      if (start >= target) {
        clearInterval(interval);
        setCount(target);
      } else {
        setCount(Math.ceil(start));
      }
    }, 16);

    return () => clearInterval(interval);
  }, [target, speed]);

  return <span>{count}</span>;
};


function FunFact() {
  return (
    <div>
      <div className="fun-fact-style-onea-rea default-padding-bottom default-padding-top bg-gray">
        <div className="container">
          <div className="fun-fact-style-one-items text-center">
            <div className="row">
              {/* Single item */}
              <div className="col-lg-3 col-md-6 funfact-style-one-item">
                <div className="fun-fact">
                  <div className="counter">
                    <div className="timer" data-to={150} data-speed={2000} >
                      <Counter target={150} speed={2000} />
                    </div>
                    <div className="operator">+</div>
                  </div>
                  <span className="medium">Project
                    Completed</span>
                </div>
              </div>
              {/* End Single item */}
              {/* Single item */}
              <div className="col-lg-3 col-md-6 funfact-style-one-item">
                <div className="fun-fact">
                  <div className="counter">
                    <div className="timer" data-to={60} data-speed={2000}>
                      <Counter target={60} speed={2000} />
                    </div>
                    <div className="operator">+</div>
                  </div>
                  <span className="medium">Happy
                    Customers</span>
                </div>
              </div>
              {/* End Single item */}
              {/* Single item */}
              <div className="col-lg-3 col-md-6 funfact-style-one-item">
                <div className="fun-fact">
                  <div className="counter">
                    <div className="timer" data-to={10} data-speed={2000}>
                      <Counter target={10} speed={2000} />
                    </div>
                    <div className="operator">+</div>
                  </div>
                  <span className="medium">Years of Experience</span>
                </div>
              </div>
              {/* End Single item */}
              {/* Single item */}
              <div className="col-lg-3 col-md-6 funfact-style-one-item">
                <div className="fun-fact">
                  <div className="counter">
                    <div className="timer" data-to={20} data-speed={2000}>
                      <Counter target={20} speed={2000} />
                    </div>
                    <div className="operator">+</div>
                  </div>
                  <span className="medium">Industries Serve</span>
                </div>
              </div>
              {/* End Single item */}
            </div>
          </div>
        </div>
      </div>

    </div>
  )
}

export default FunFact
